import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

Vue.use(Router)
Vue.use(VueMeta)

// Components
import LandingPage from '@/components/pages/landing-page'
import PersonDetails from '@/components/pages/person-details'
import SeatingType from '@/components/pages/seating-type'
import ScheduleDuration from '@/components/pages/schedule-duration'
import SlotAvailability from '@/components/pages/slot-availability'
import MoreDateAvailability from '@/components/pages/slot-availability/more-dates'
import Inventory from '@/components/pages/inventory'
import Services from '@/components/pages/services'

import AdditionalInfo from '@/components/pages/additional-information'


export default new Router({
    routes: [
        {
            path: '/:event_type?',
            name: 'LandingPage',
            // component: () => import(/* webpackChunkName: "landing-page" */'@/components/pages/landing-page'),
            component: LandingPage
        },
        {
            path: '/person-details',
            name: 'PersonDetails',
            component: PersonDetails
        },
        {
            path: '/seating-type',
            name: 'SeatingType',
            component: SeatingType
        },
        {
            path: '/schedule-duration',
            name: 'ScheduleDuration',
            component: ScheduleDuration
        },
        {
            path: '/slot-availability',
            name: 'SlotAvailability',
            component: SlotAvailability
        },
        {
            path: '/slot-availability/try-more-dates',
            name: 'MoreDateAvailability',
            component: MoreDateAvailability
        },
        {
            path: '/inventory',
            name: 'Inventory',
            component: Inventory
        },
        {
            path: '/services',
            name: 'Services',
            component: Services
        },
        {
            path: '/additional-information',
            name: 'AdditionalInfo',
            component: AdditionalInfo,
            redirect: { name: 'AdditionalInfoOverNight' },
            children: [
                {
                    path: 'overnight-stay-offer',
                    name: 'AdditionalInfoOverNight',
                    component: () => import(/* webpackChunkName: "overnight-stay-offer" */'@/components/pages/additional-information/overnight-stay'),
                },
                {
                    path: 'other-wishes',
                    name: 'AdditionalInfoOtherWishes',
                    component: () => import(/* webpackChunkName: "other-wishes" */'@/components/pages/additional-information/other-wishes'),
                }
            ]
        },
        {
            path: "/checkout/confirm",
            name: "Checkout",
            component: () => import(/* webpackChunkName: "checkout" */'@/components/pages/checkout')
        },
        {
            path: "/checkout/finish",
            name: "Finish",
            component: () => import(/* webpackChunkName: "checkout" */'@/components/pages/finish')
        },
        {
            path: "*",
            component: () => import(/* webpackChunkName: "error-pages" */'@/components/pages/error/404')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js